// Others
import axiosClient from './axiosClient';
import { urlApiTimeClock } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IParamsHoursWorked, IPayrollExportHour } from '~/utils/interface/payroll';
import {
  IExportTimeClock,
  IQueryParamTimeClock,
  ITimeClock,
  ITimeClockDetail,
} from '~/utils/interface/timeClock';

const timeClockApi = {
  getTimeClockList: (params: IQueryParamTimeClock) => {
    const url = urlApiTimeClock.getListTimeClock;
    return axiosClient.get<IBaseResponse<IListDataResponse<ITimeClock[]>>>(url, { params });
  },

  deleteTimeClock: (timeClockId: string) => {
    const url = urlApiTimeClock.deleteTimeClock(timeClockId);
    return axiosClient.delete<IBaseResponse>(url);
  },

  getTimeClockDetails: (timeClockId: string) => {
    const url = urlApiTimeClock.getTimeClockDetails(timeClockId);
    return axiosClient.get<IBaseResponse<ITimeClockDetail>>(url);
  },
  exportTimeClocks: (timeZone: string) => {
    const url = urlApiTimeClock.exportTimeClocks;
    return axiosClient.post<IBaseResponse<IExportTimeClock>>(url, { timeZone: timeZone });
  },
  getTimeClockHoursWorked: (params: IParamsHoursWorked) => {
    const url = urlApiTimeClock.getTimeClockHoursWorked;
    return axiosClient.get<IBaseResponse<IPayrollExportHour[]>>(url, { params });
  },
};

export default timeClockApi;
